import { cn } from '@/components/ui/utils';
import React from 'react';
import { InferBaseHtmlType } from '../utils';

type BaseType = React.ComponentProps<'div'>;
export type TappFormFieldProps = { children: React.ReactNode } & BaseType;

const TappFormField = React.forwardRef<InferBaseHtmlType<BaseType>, TappFormFieldProps>(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <div ref={forwardedRef} className={cn('flex flex-shrink flex-col text-[0px] gap-1 w-full', className)} {...props}>
        {children}
      </div>
    );
  }
);

TappFormField.displayName = 'TappFormField';
export { TappFormField };
